import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Bind } from 'lodash-decorators';

import { scrollToElementCenter } from '../../utils/utils';
import { KENTICO_TYPES } from '../../consts/kentico';

import AccordionPanel from './components/AccordionPanel/AccordionPanel';
import TwoColumnsAccordionPanel from './components/TwoColumnsAccordionPanel/TwoColumnsAccordionPanel';

import styles from './AccordionList.module.scss';

export default class AccordionList extends Component {
  static propTypes = {
    accordionList: PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.shape({
          description: PropTypes.string,
          id: PropTypes.string,
          file: PropTypes.array,
          title: PropTypes.string
        }),
        PropTypes.shape({
          id: PropTypes.string,
          panels: PropTypes.array,
          title: PropTypes.string
        })
      ])
    )
  };

  state = {
    openedId: null
  };

  @Bind
  open(e, index) {
    if (this.state.openedId === index) {
      this.setState({
        openedId: null
      });
      return;
    }

    this.setState({
      openedId: index
    });

    scrollToElementCenter(e.target, 200);
  }

  render() {
    const { openedId } = this.state;
    const { accordionList } = this.props;

    return (
      <ul className={styles.AccordionList}>
        {accordionList &&
          accordionList.map((panel, index) => {
            if (panel.system.type === KENTICO_TYPES.TWO_COLUMNS_PANEL) {
              return (
                <TwoColumnsAccordionPanel
                  key={panel.id}
                  isOpen={openedId === index}
                  onClose={e => this.open(e, index)}
                  title={panel.title}
                  panels={panel.panels}
                />
              );
            }

            return (
              <AccordionPanel
                key={panel.id}
                description={panel.description}
                file={panel.file}
                isOpen={openedId === index}
                onClose={e => this.open(e, index)}
                title={panel.title}
              />
            );
          })}
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/AccordionList/AccordionList.js